import { render } from "./DetailsInteractionVideo.vue?vue&type=template&id=05b9fed2"
import script from "./DetailsInteractionVideo.vue?vue&type=script&lang=js"
export * from "./DetailsInteractionVideo.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Proyectos\\Vue3\\player-video-pepsi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__